import { render, staticRenderFns } from "./SignupModal.vue?vue&type=template&id=2153d3d6&"
import script from "./SignupModal.vue?vue&type=script&lang=js&"
export * from "./SignupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports